import React from "react";

import usePageMeta from "../utils/usePageMeta";
import { SITE_NAME, CONTACT_EMAIL } from "../utils/site";

const About = () => {
  usePageMeta({
    title: "About and contact",
    description: `Who runs ${SITE_NAME}, where the draw data comes from, how it is calculated, and how to get in touch.`,
    path: "/about",
  });

  return (
    <div className="page prose">
      <h1>About {SITE_NAME}</h1>

      <p>
        {SITE_NAME} publishes California Daily 3 and Daily 4 draw results as they
        are released, alongside simple frequency analytics that show how the
        digits have actually fallen. It is run by one person as an independent
        project, and it is not affiliated with, endorsed by, or connected to the
        California State Lottery in any way.
      </p>

      <h2>What we do, and what we deliberately do not</h2>
      <p>
        Everything on this site is descriptive. We report what has already been
        drawn and count how often each digit appeared. That is the whole of it.
      </p>
      <p>
        We do not predict draws, and we do not sell systems, subscriptions, or
        number packages. Lottery draws are independent events: past results carry
        no information about future ones, and no amount of frequency analysis
        changes the odds of the next draw. Where our charts show a digit appearing
        more often than average, that is ordinary sampling variation, not a
        pattern — and we say so on the page rather than leaving the impression
        open.
      </p>
      <p>
        The number generator on the home page produces random picks for
        entertainment. Its output is not informed by the analytics, because
        nothing could reasonably inform it.
      </p>

      <h2>Where the data comes from</h2>
      <p>
        Draw results are read from the California Lottery's published results
        feed at the time you load the page, so what you see reflects what they
        have posted. Frequency figures are computed from the most recent draws
        available in that feed. If a result looks wrong, the California Lottery's
        own published results are the authority, not this site.
      </p>

      <h2>Community</h2>
      <p>
        Signed-in visitors can post and comment. Posts express the views of
        whoever wrote them, not ours. Authors can delete their own posts and
        comments, and the author of a post can remove comments left on it.
      </p>

      <h2>Play responsibly</h2>
      <p>
        You must be 18 or older to play the California Lottery. Playing should be
        entertainment you can comfortably afford, never a financial strategy. If
        it stops feeling that way, free and confidential help is available around
        the clock on <strong>1-800-GAMBLER</strong> (1-800-426-2537).
      </p>

      <h2>Contact</h2>
      <p>
        Questions, corrections, or requests about your data are welcome at{" "}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>. Corrections to
        published figures are the ones we most want to hear about.
      </p>
    </div>
  );
};

export default About;
